import { featureToggleSelector } from './featureToggleSelector';
import { IState } from '../../store';

export const selectNewbuildingMortgageCalculatorMicrofrontEnabled = (state: IState) =>
  featureToggleSelector(state).newbuildingMortgageCalculatorMicrofrontEnabled;
